import axios from "axios";
import store from "../store";
import envUrl from "../api/envUrl";

const baseUrl = envUrl.baseUrl;

const request = axios.create({
    baseURL: baseUrl, // 设置请求的基础URL
    timeout: 60000, // 设置请求超时时间
    withCredentials: true
});

// 请求拦截器
request.interceptors.request.use(
    config => {
        let { business } = store.state;
        if (Object.prototype.toString.call(config.data) === "[object FormData]") {
            config.headers["Content-Type"] = "multipart/form-data";
            return config;
        }
        if (config.method === "get") {
            config.params = {
                ...config.params
            };
        } else {
            config.data = {
                ...config.data
            };
        }
        return config;
    },
    error => {
        // 处理请求错误
        return Promise.reject(error);
    }
);

// 响应拦截器
request.interceptors.response.use(
    response => {
        // 在响应数据之前做一些处理
        return response.data;
    },
    error => {
        // 处理响应错误
        return Promise.reject(error);
    }
);

export default request;
